import { gql } from '@apollo/client';
import type { InhubTransportPerspective } from '../types';

export const GET_INHUB_TRANSPORT_ROUTE_SUMMARIES_PAGE = gql`
  query GetInhubTransportRouteSummariesPage($filter: InhubTransportRoutePageInput!) {
    getInhubTransportRouteSummariesPage(filter: $filter) {
      content {
        fromHubId
        fromHubName
        toHubId
        toHubName
        perspective
        departedParcelCount
        departedBagCount
        arrivedParcelCount
        arrivedBagCount
        notArrivedParcelCount
        notArrivedBagCount
        over72hUnarrivedBagCount
        status
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export type InhubTransportRouteOrderField =
    | 'PEER_HUB_ID'
    | 'DEPARTED_PARCEL_COUNT'
    | 'DEPARTED_BAG_COUNT'
    | 'ARRIVED_PARCEL_COUNT'
    | 'ARRIVED_BAG_COUNT'
    | 'NOT_ARRIVED_PARCEL_COUNT'
    | 'NOT_ARRIVED_BAG_COUNT'
    | 'STATUS';

export type SortDirection = 'ASC' | 'DESC';

export type InhubTransportRowStatus = 'ALL_ARRIVED' | 'BAG_PENDING' | 'OVER_72H';

export interface InhubTransportRoutePageInput {
    hubId: number;
    rangeStart: string;
    rangeEnd: string;
    perspective: InhubTransportPerspective;
    page: number;
    pageSize: number;
    orderBy?: InhubTransportRouteOrderField;
    orderDir?: SortDirection;
}

export interface InhubTransportRouteRowResp {
    fromHubId: number;
    fromHubName: string;
    toHubId: number;
    toHubName: string;
    perspective: InhubTransportPerspective;
    departedParcelCount: number;
    departedBagCount: number;
    arrivedParcelCount: number;
    arrivedBagCount: number;
    notArrivedParcelCount: number;
    notArrivedBagCount: number;
    over72hUnarrivedBagCount: number;
    status: InhubTransportRowStatus;
}

export interface GetInhubTransportRouteSummariesPageResponse {
    getInhubTransportRouteSummariesPage: {
        content: InhubTransportRouteRowResp[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}
